// Styles
import "@mdi/font/css/materialdesignicons.css";
import 'vuetify/styles';

// Vuetify
import { createVuetify } from 'vuetify';
import { aliases, mdi } from "vuetify/iconsets/mdi";

export default createVuetify({
  locale: {
    // adapter: createVueI18nAdapter({ i18n, useI18n }),
  },
 icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  breakpoint: {
    scrollBarWidth: 16,
    thresholds: {
      xs: 576,
      sm: 768,
      md: 992,
      lg: 1200,
      xl: 1400,
    },
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        colors: {
          primary: '#47bdc2',
          secondary: '#152742'
        },
        dark: false,
      },
    },
    defaultTheme: 'light',
  },
});
